module.exports = __webpack_public_path__ + "img/social-tiktok.d30882d.svg";